'use client';

import React, { FC } from 'react';

export interface UserIconProps {
  className?: string;
  width?: number;
  height?: number;
}

export const UserIcon: FC<UserIconProps> = ({
  className = '',
  width = 27,
  height = 29,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 27 29"
    fill="currentColor"
    className={className}
  >
    <path
      d="M4.72984 18.5941C6.25798 17.0908 8.1785 15.9738 10.3274 15.4053C9.52411 15.0321 8.7984 14.5261 8.1785 13.916C6.79498 12.5542 5.93877 10.6725 5.93877 8.59472C5.93877 6.51691 6.7941 4.63525 8.1785 3.27348C9.56203 1.91171 11.4737 1.06982 13.5847 1.06982C15.6957 1.06982 17.6074 1.91171 18.991 3.27348C20.3745 4.63525 21.2307 6.51691 21.2307 8.59472C21.2307 10.6725 20.3754 12.5542 18.991 13.916C18.3711 14.5261 17.6445 15.0321 16.842 15.4053C18.991 15.9738 20.9124 17.09 22.4396 18.5941C24.7058 20.8246 26.107 23.9058 26.107 27.3097C26.107 27.6691 25.8116 27.9598 25.4465 27.9598H1.72296C1.3579 27.9598 1.0625 27.6691 1.0625 27.3097C1.0625 23.9066 2.46366 20.8246 4.72984 18.5941ZM18.0571 4.19348C16.9126 3.06692 15.3315 2.37084 13.5847 2.37084C11.8379 2.37084 10.2569 3.06778 9.1132 4.19348C7.96864 5.32004 7.26057 6.87623 7.26057 8.59559C7.26057 10.3141 7.96864 11.8711 9.1132 12.9968C10.2578 14.1234 11.8388 14.8203 13.5847 14.8203C15.3315 14.8203 16.9126 14.1234 18.0571 12.9968C19.2017 11.8703 19.9089 10.3141 19.9089 8.59559C19.9089 6.87623 19.2008 5.32004 18.0571 4.19348ZM5.66454 19.5141C3.78281 21.3662 2.56771 23.8745 2.40369 26.6597H24.7666C24.6017 23.8745 23.3867 21.3662 21.5058 19.5141C19.4795 17.5196 16.6789 16.2854 13.5856 16.2854C10.4923 16.2854 7.69264 17.5196 5.66542 19.5141H5.66454Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.5"
    />
  </svg>
);

export default UserIcon;
